import React, { useEffect } from "react";
import { ClientS, Faq, Footer, Header, Help, How, LidMagnets, Main, Preim, Present, Price } from "./components";
import './styles/page.scss'

function App() {
  useEffect(() => {
    // Получаем параметр r из URL
    const urlParams = new URLSearchParams(window.location.search);
    const referralId = urlParams.get('r');
    
    if (referralId) {
      // Настройка куки для всех поддоменов
      const domain = window.location.hostname.split('.').slice(-2).join('.'); // получаем основной домен (например, example.com)
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 7); // 7 дней
      
      // Сохраняем куки
      document.cookie = `referral_id=${encodeURIComponent(referralId)}; domain=.${domain}; path=/; expires=${expiryDate.toUTCString()}; SameSite=Lax`;
    }
  }, []);

  return (
    <div className="wrapper">
      <Header />
      <Main />
      <ClientS />
      {/*<Help />*/}
      <How />
      <Present />
      {/*<LidMagnets />*/}
      {/*<Preim />*/}
      <Price />
      <Faq />
      <Footer />
    </div>
  );
}

export default App;